"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSpecificPlans = exports.GetPlans = exports.GetPlanTemplates = exports.GetDeploymentPlans = exports.PlansNodeFields = exports.PlanFields = exports.PlanTemplateFields = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.PlanTemplateFields = (0, graphql_tag_1.default) `
  fragment PlanTemplateFields on PlanTemplate {
    id
    period
    dailyReqCap
    rateLimit
    metadata
    active
  }
`;
exports.PlanFields = (0, graphql_tag_1.default) `
  fragment PlanFields on Plan {
    id
    active
    creator
    deploymentId
    price
  }
`;
exports.PlansNodeFields = (0, graphql_tag_1.default) `
  fragment PlansNodeFields on Plan {
    id
    active
    creator
    deploymentId
    price
    planTemplate {
      id
      period
      dailyReqCap
      rateLimit
      metadata
      active
    }
  }
`;
exports.GetDeploymentPlans = (0, graphql_tag_1.default) `
  query GetDeploymentPlans($address: String!, $deploymentId: String!) {
    plans(
      filter: {
        creator: { equalTo: $address }
        and: [
          { active: { equalTo: true } }
          { or: [{ deploymentId: { isNull: true } }, { deploymentId: { equalTo: $deploymentId } }] }
        ]
      }
    ) {
      totalCount
      nodes {
        ...PlanFields
        planTemplate {
          ...PlanTemplateFields
        }
      }
    }
  }
  ${exports.PlanFields}
  ${exports.PlanTemplateFields}
`;
exports.GetPlanTemplates = (0, graphql_tag_1.default) `
  query GetPlanTemplates($offset: Int) {
    planTemplates(first: 10, offset: $offset, filter: { active: { equalTo: true } }) {
      totalCount
      nodes {
        ...PlanTemplateFields
      }
    }
  }
  ${exports.PlanTemplateFields}
`;
exports.GetPlans = (0, graphql_tag_1.default) `
  query GetPlans($address: String!) {
    plans(
      filter: {
        creator: { equalTo: $address }
        and: { deploymentId: { isNull: true } }
        active: { equalTo: true }
      }
    ) {
      totalCount
      nodes {
        ...PlanFields
        planTemplate {
          ...PlanTemplateFields
        }
      }
    }
  }
  ${exports.PlanFields}
  ${exports.PlanTemplateFields}
`;
exports.GetSpecificPlans = (0, graphql_tag_1.default) `
  query GetSpecificPlans($address: String) {
    deploymentIndexers(filter: { indexerId: { equalTo: $address } }) {
      totalCount
      nodes {
        deployment {
          id
          project {
            id
            metadata
          }
          plans(filter: { creator: { equalTo: $address }, and: { active: { equalTo: true } } }) {
            nodes {
              ...PlanFields
              planTemplate {
                ...PlanTemplateFields
              }
            }
          }
        }
      }
    }
  }
  ${exports.PlanFields}
  ${exports.PlanTemplateFields}
`;
//# sourceMappingURL=plans.generated.js.map